module.exports = __webpack_public_path__ + "img/btn.aec75f86.png";